module.exports = __webpack_public_path__ + "posture/static/img/high_low_shoulder_left.875b362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/high_low_shoulder_left.png
// module id = 1V3F
// module chunks = 1